module.exports = __webpack_public_path__ + "img/pic_jinghuaru2.e2de0d90.png";